import { useCallback } from 'react';
import DialogView from '../../../components/dialog-view/DialogView';
import { DialogContent } from '../components/Styles';
import styled from 'styled-components';
import { isDevice } from '../../../utils/device-handling/deviceDetectionUtils';
import ReturnGoodsViewContent from './ReturnGoodsViewContent';
import { useNavigate } from '../../../hooks/useNavigate';

interface Props {
  showReceipt?: () => void;
  onClose?: () => void;
}

const ReturnGoodsView = (props: Props) => {
  const { onClose, showReceipt } = props;

  const fullscreenTask = isDevice();

  const navigate = useNavigate();

  const handleCloseDialog = useCallback(() => {
    onClose && onClose();
  }, [onClose]);

  const handleCloseTask = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <>
      {fullscreenTask ? (
        <FullScreenContainer>
          <ReturnGoodsViewContent showReceipt={showReceipt} onClose={handleCloseTask} />
        </FullScreenContainer>
      ) : (
        <DialogView handleClose={handleCloseDialog}>
          <StyledDialogContent>
            <ReturnGoodsViewContent showReceipt={showReceipt} onClose={handleCloseDialog} />
          </StyledDialogContent>
        </DialogView>
      )}
    </>
  );
};

const FullScreenContainer = styled.div`
  height: 100vh;
  width: 100vw;
`;

const StyledDialogContent = styled(DialogContent)`
  width: 70vw;
  height: 70vh;
  padding: 0;
`;

export default ReturnGoodsView;
